import React from 'react';
import '../../assets/css/style.css';
import InterestsCarousel from './elements/InterestsCarousel';
import ProfileChipContainer from './elements/ProfileChipContainer';

const ProfileInterest = () => {
    const availableInterests = [
        "baking","netflix","road-trips","spirituality","cooking","sports","writing",
        "coffee","drinking","reading","clubbing","food","museums",
        "crafts","art","board-games","gaming","podcasts","dancing","photography",
        "tech","ice-skating","karaoke","karate","knitting","lacrose","make-up",
        "movies","tattoos","running", "rugby","politics","pets","meditating",
        "painting","poetry","puzzles","quizzes","martial-arts","social-media","shopping",
        "soccer","sailing","sky-diving","surfing","swimming","thrifting","tennis",
        "travel","tourism","videography","vr","volunteering","wrestling","yoga",
        "zumba","zoo","youtube"
    ];

    const getCurrentContainers = () => {
        const containers = [
            <ProfileChipContainer interests={availableInterests.slice(0,21)} />,
            <ProfileChipContainer interests={availableInterests.slice(22,43)} />,
            <ProfileChipContainer interests={availableInterests.slice(44,58)} />
        ];

        return <InterestsCarousel containers={containers} />
    }

    return (
        <div className="uni-form">
            <div className="uni-interests-grp" style={{ display: 'flex' }}>
                {getCurrentContainers()}
            </div>
        </div>
    );
};

export default ProfileInterest;